import { Button } from '@britishcouncil/react-admin';
import { Modal } from 'semantic-ui-react';
import { Link, generatePath } from 'react-router';
import { ROUTING_PATHS } from 'const';

type Props = {
  isCreating: boolean;
  created: boolean;
};

export const Footer = ({ isCreating, created }: Props) => {
  const { lrwSessions } = ROUTING_PATHS;

  return (
    <Modal.Actions>
      <Link to={generatePath(lrwSessions.absolutePath)}>
        <Button compact type="reset" secondary>
          Cancel
        </Button>
      </Link>

      <Button
        compact
        color="blue"
        type="submit"
        disabled={isCreating || created}
        loading={isCreating}
      >
        Create
      </Button>
    </Modal.Actions>
  );
};
